import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";

import {
  applyThemeFromRoute,
  routingComponentErrorHandler,
} from "shared/helpers/routing";

import routes from "./routes";

export default function router() {
  const historyFunction =
    import.meta.env.QUASAR_VUE_ROUTER_MODE === "history"
      ? createWebHistory
      : createWebHashHistory;

  const createHistory = import.meta.env.QUASAR_SERVER
    ? createMemoryHistory
    : historyFunction;

  const Router = createRouter({
    // Leave this as is and make changes in quasar.config.js instead!
    // quasar.config.js -> build -> vueRouterMode
    // quasar.config.js -> build -> publicPath
    history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE),
    routes,

    scrollBehavior: () => ({ left: 0, top: 0 }),
  });

  Router.beforeEach(routingComponentErrorHandler);
  Router.beforeEach(applyThemeFromRoute);

  return Router;
}
